import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { SlateComponentContext, useSlate, useSlateComponent, useSlateKit, } from '../hooks';
import { compileProps } from '../utils/props-compiler.utils';
import { getSlateComponentProps } from '../utils/slate-component-props.utils';
export const SlateComponentRenderer = ({ componentIds, }) => {
    const slateKitProps = useSlateKit();
    const { kit } = slateKitProps;
    const slateProps = useSlate();
    const { slate, context } = slateProps;
    const { componentId: parentComponentId, componentLevel } = useSlateComponent();
    if (!slate || !componentIds)
        return null;
    const flatComponentIds = Array.isArray(componentIds)
        ? componentIds
        : [componentIds];
    const result = flatComponentIds
        .map(componentId => {
        const component = slate.components[componentId];
        if (!component)
            return null;
        const { name, props = {}, children = [] } = component;
        if (!name)
            return null;
        const childrenComponent = children.map(child => (_jsx(SlateComponentRenderer, { componentIds: child }, child.toString())));
        const compiledProps = compileProps(props, context);
        const loadedComponent = kit.loadComponent({
            key: componentId,
            name,
            compiledProps,
            children: childrenComponent,
        });
        return loadedComponent ? (_jsx(SlateComponentContext.Provider, Object.assign({ value: getSlateComponentProps(slateKitProps, slateProps, {
                componentId,
                parentComponentId,
                componentLevel,
            }) }, { children: loadedComponent }), componentId)) : null;
    })
        .filter(c => c);
    if (result.length === 1)
        return result[0];
    return _jsx(_Fragment, { children: result }, void 0);
};
//# sourceMappingURL=SlateComponentRenderer.component.js.map